<template>
  <div class="step-line row">
    <img src="/Scripts/vue/tracking/img/step-check-open.svg" alt="" class="step-line-icon" />
    <div v-if="index + 1 < stepCount" class="grey-line"></div>
    <div class="col-xs-4 col-sm-3 col-md-3 time">
      <p>{{ timeText }}</p>
    </div>
    <div class="col-xs-8 col-sm-9 col-md-9 libelle">
      <p>{{ step.Libelle }}</p>
    </div>
    <template v-if="showContextualTracking">
      <div class="col-xs-4 col-sm-3 col-md-3"></div>
      <div class="col-xs-8 col-sm-9 col-md-9 libelle" v-html="contextualTracking"></div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    step: { type: Object, required: true },
    showContextualTracking: { type: Boolean, default: false },
    index: { type: Number, required: true },
    stepCount: { type: Number, required: true },
  },
  computed: {
    ...mapState(['contextualTracking']),
    locale() {
      const lang = this.nameLangue || 'fr-FR';
      return lang.length === 4 && !lang.includes('-')
        ? `${lang.slice(0, 2)}-${lang.slice(2)}`
        : lang;
    },
    timeText() {
      const d = new Date(this.step?.Date);
      if (Number.isNaN(d.getTime())) return '';
      return d.toLocaleTimeString(this.locale, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import './StepLine.scss';
</style>
